import React from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {RootState} from "../../../reducers";
import Money from "../Common/Money";
import {getSession} from "../../services/Session/reducer";
import {getCart} from "../../services/Cart/reducer";

type Props = ReturnType<typeof mapStateToProps> & DispatchProp;

const CartSubmitInfoComponent = ({session, cart}: Props) => {
    const {t} = useTranslation();
    const minOrderPrice = session.order_type === "DELIVERY" ? session.min_order_price_money : session.default_min_order_price_money;
    const showMinOrderPriceInfo = minOrderPrice?.amount > 0 && cart.total?.amount < minOrderPrice?.amount;

    if (!showMinOrderPriceInfo) return <></>;

    return (
        <div className={"cart-submit-info-after"}>
            <div className={"text-center mt-3"}>
                <p className='mb-0'>
                    {t("common.word.min_order_price")}: <strong><Money
                    value={minOrderPrice}/></strong>
                </p>
            </div>
        </div>
    )
}


const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session),
    cart: getCart(state.cart),
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(CartSubmitInfoComponent));
